import { RefObject, useEffect, useState, useCallback } from 'react'

function throttle(func: Function, limit: number) {
  let lastFunc: ReturnType<typeof setTimeout>
  let lastRan: number
  return function (...args: any[]) {
    if (!lastRan) {
      func.apply(this, args)
      lastRan = Date.now()
    } else {
      clearTimeout(lastFunc)
      lastFunc = setTimeout(() => {
        if (Date.now() - lastRan >= limit) {
          func.apply(this, args)
          lastRan = Date.now()
        }
      }, limit - (Date.now() - lastRan))
    }
  }
}

// TODO: will be replaced by an Affix component once it's added
export function useAffix(options: { containerRef: RefObject<HTMLDivElement>; enabled: boolean }): [boolean] {
  const [isAffixed, setIsAffixed] = useState(false)

  const handleScroll = useCallback(() => {
    if (options.containerRef.current) {
      const rect = options.containerRef.current.getBoundingClientRect()
      // Componentin alt kısmı viewport'un üst kısmına geldiğinde sticky başlayacak
      const shouldAffix = rect.bottom <= 0
      requestAnimationFrame(() => {
        if (isAffixed !== shouldAffix) {
          setIsAffixed(shouldAffix)
        }
      })
    }
  }, [options.containerRef, isAffixed])

  useEffect(() => {
    const throttledScroll = throttle(handleScroll, 16) // 60fps için ~16ms

    if (options.enabled) {
      window.addEventListener('scroll', throttledScroll, { passive: true })
    }
    return () => {
      if (options.enabled) {
        window.removeEventListener('scroll', throttledScroll)
      }
    }
  }, [handleScroll, options.enabled])

  return [isAffixed]
}
